// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Scale = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Scale = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Scale = _exports.Scale = function Scale(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_8528_27846)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M11.4085 7.36809C11.0696 7.70703 11.0696 8.25511 11.4085 8.59044C11.7474 8.92578 12.2955 8.92939 12.6309 8.59044L17.4986 3.72266V6.82722C17.4986 7.30679 17.8845 7.69261 18.364 7.69261C18.8436 7.69261 19.2294 7.30679 19.2294 6.82722V1.63492C19.2294 1.15535 18.8436 0.769531 18.364 0.769531H13.1753C12.6958 0.769531 12.3099 1.15535 12.3099 1.63492C12.3099 2.11448 12.6958 2.5003 13.1753 2.5003H16.2799L11.4085 7.36809ZM8.596 12.6325C8.93495 12.2936 8.93495 11.7455 8.596 11.4102C8.25706 11.0748 7.70899 11.0712 7.37365 11.4102L2.50225 16.2779V13.1734C2.50225 12.6938 2.11644 12.308 1.63687 12.308C1.1573 12.308 0.771484 12.6938 0.771484 13.1734V18.3657C0.771484 18.8453 1.1573 19.2311 1.63687 19.2311H6.82918C7.30874 19.2311 7.69456 18.8453 7.69456 18.3657C7.69456 17.8861 7.30874 17.5003 6.82918 17.5003H3.72461L8.596 12.6325Z",
      fill: "#212B36"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_8528_27846"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      fill: "white"
    }))));
  };
});
